module.exports = __webpack_public_path__ + "assets/img/warrior-name-4c97f3b4.png";